<template>
  <div class="h5-result">
    <div v-if="!result.isWreck" class="wreck">
      <div class="title">
        <i class="el-icon-error" style="font-size: 40px; color: #ec6453"></i>
        <span style="color: #ec6453">验证失败</span>
      </div>
      <div class="tip">PDF文件已损坏或未签名</div>
    </div>

    <div v-if="result.isWreck && !result.concur" class="other">
      <div class="title">
        <i class="el-icon-error" style="font-size: 40px; color: #ec6453"></i>
        <span style="color: #ec6453">验证失败</span>
      </div>
      <div class="tip">未验证到本公司有效数字签名</div>
    </div>
    
    <div v-if="result.isWreck && result.concur" class="success-fail">
      <div v-if="result.verified && !result.modified" class="title">
        <i class="el-icon-success" style="font-size: 40px; color: #00a758"></i>
        <span style="color: #00a758">验证成功</span>
      </div>
      <div v-else class="title">
        <i class="el-icon-error" style="font-size: 40px; color: #ec6453"></i>
        <span style="color: #ec6453">验证失败</span>
      </div>
      <div class="content">
        <div class="info">
          <h5>数字证书颁发机构：</h5>
          <p>{{ result.organization || "-" }}</p>
        </div>
        <!-- <div class="info">
        <h5>数字证书颁发单位：</h5>
        <p>{{ result.ou || "-" }}</p>
      </div> -->
        <div class="info">
          <h5>数字证书持有人：</h5>
          <p>{{ result.holder || "-" }}</p>
        </div>
        <div class="info">
          <h5>文件名称：</h5>
          <p>{{ result.fileName || "-" }}</p>
        </div>
        <div class="info">
          <h5>数字证书是否有效：</h5>
          <p>
            {{
              result.verified === true
                ? "有效"
                : result.verified === false
                ? "无效"
                : "-"
            }}
          </p>
        </div>
        <div class="info">
          <h5>数字签名是否被更改：</h5>
          <p>
            {{
              result.modified === true
                ? "是"
                : result.modified === false
                ? "否"
                : "-"
            }}
          </p>
        </div>
        <div class="info">
          <h5>签名日期：</h5>
          <p>{{ result.signdate ? this.formatDate(result.signdate) : "-" }}</p>
        </div>
        <div class="info">
          <h5>提交时间：</h5>
          <p>
            {{ result.submitDate ? this.formatDate(result.submitDate) : "-" }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/utils";
export default {
  name: "H5Success",

  props: {
    result: {
      required: true,
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {};
  },

  methods: {
    formatDate,
  },
};
</script>

<style scoped lang="scss">
.h5-result {
  width: 100%;
  // padding: 15px 0 30px;
  // border: 2px solid #e2e2e2;
  border-radius: 5px;

  .wreck, .other {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0 0 0;

    > div.tip {
      padding-bottom: 40px;
    }

    > i {
      font-size: 40px; 
      color: #ec6453;
    }
    > span {
      margin-left: 10px;
    }
  }

  .success-fail {
    padding: 15px 0 30px;
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0 20px;
    > span {
      margin-left: 5px;
      font-size: 20px;
      font-weight: bold;
      color: green;
    }
  }

  .info {
    display: flex;
    padding: 8px;
    > h5 {
      white-space: nowrap;
      font-size: 14px;
      font-weight: bold;
    }
    > p {
      font-size: 13px;
    }
  }
}
</style>